module.exports = __webpack_public_path__ + "static/media/Moby-logo.a137c721.png";